import Grid from './src/grid.vue'
import GridItem from './src/grid-item.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToGrid: SFCWithInstall<typeof Grid> = withInstall(Grid)
export const ToGridItem: SFCWithInstall<typeof GridItem> = withInstall(GridItem)

export default ToGrid

export * from './src/instance'
